<template>
  <edit-buttons v-if="entry" />
  <start-buttons v-else />
</template>

<script>
import { mapState } from 'vuex';
import EditButtons from './EditButtonsContainer';
import StartButtons from './StartButtonsContainer';
export default {
  components: {
    EditButtons,
    StartButtons
  },
  computed: {
    ...mapState('entryForm', ['entry'])
  }
};
</script>
